import { FC, useEffect, useState } from "react";
import { IActionAttributes, IActionBaseAttributes } from "../../../base/models";

import { ActionComponent } from "./ActionComponent";
import { ActionGroupComponent } from "./ActionGroupComponent";
import { ActionType } from "../../../base/types";
import { useDesignContext } from "../../../providers";
import { useGetPropertyValues } from "../../../base/hooks";

export const PageAction: FC<IActionBaseAttributes> = ({
    action, className, children, onDesignChange
}) => {
    const { action: { designerMode } } = useDesignContext()
    const props = useGetPropertyValues(action.bindings);
    const [actionProps, setActionProps] = useState<IActionAttributes>()

    useEffect(() => {
        setActionProps({
            action,
            className,
            children,
            props,
            designerMode,
            onDesignChange
        })
        // eslint-disable-next-line
    }, [props])

    if (!actionProps) return <></>

    switch (action.type) {
        case ActionType.Action:
        case ActionType.ActionLink:
        case ActionType.TOULink:
        case ActionType.UMSLink:
            return <ActionComponent {...actionProps} />
        case ActionType.ActionGroup:
            return <ActionGroupComponent {...actionProps} />
        default:
            return (
                <div className="card">
                    <div className="card-body p-2">
                        {action.type}
                    </div>
                </div>)
    }
} 